import { SWRConfiguration } from 'swr';
import useSWRMutation from 'swr/mutation';
import { client } from '../api/client';
import { SaveAsmBadgePrint, SaveAsmBadgePrintResponse } from '../api/dtos';

async function saveAsmBadgeFetcher( _key: string, { arg }: { arg: SaveAsmBadgePrint }): Promise<SaveAsmBadgePrintResponse> {
    return await client.post(arg);
}

export const useSaveAsmBadge = (configuration: SWRConfiguration = {}) => {
    const { trigger, data, error, isMutating } = useSWRMutation(
        'SaveAsmBadgePrint',
        saveAsmBadgeFetcher
    );

    return {
        saveAsmBadge: trigger,
        data,
        error,
        pending: isMutating,
        response: data,
    };
};

export default useSaveAsmBadge;
